import styled from '@emotion/styled';
import { TabletWidth } from '../../global.style';
import { getColor } from './UICommon';

export const PickPlanSummaryCardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  text-align: center;
  padding: 47px 155px 39px;
  border-radius: 18px;
  background-color: #eae2da;
  width: 689px;
  margin: 106px auto 18px;
  z-index: 1;
  position: relative;

  @media (max-width: ${TabletWidth}px) {
    padding: 45px 21px 44px;
    width: calc(100% - 44px);
    margin: 62px 22px 0;
  }
`;

export const PickPlanSummaryCardTitle = styled.div`
  color: ${getColor('BLACK')};
  font-family: Lora;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 17px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 144%;
    margin-bottom: 28px;
  }
`;

export const PickPlanSummaryCardSubtitle = styled.div`
  color: ${getColor('BLACK')};
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  @media (max-width: ${TabletWidth}px) {
    font-size: 14px;
  }
`;
